import React, { useEffect } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { useRouteMatch, useLocation } from 'react-router-dom';

import OAuthCache from './oauth-strategy-cache';
import { startIntegrationFlow, IntegrationFlowParams } from './oauth-strategy.state';
import { OAuthStrategyOptions } from './oauth-strategy.types';
import {
    getRedirectUri,
    getAdditionalParamsFromQuerystring,
} from './oauth-strategy-utils';

import { parseQS } from '../../../../shared/utils/qs';
import Loading from '../../../../shared/components/loading/Loading';

type RouterParams = {
  params: {
    providerId: string
  }
}

type QueryParams = {
  state: string
  code: string
}

type Props = {
  startIntegration: (params: IntegrationFlowParams) => void;
}

const OAuthStrategyCallbackComponentImpl = ({ startIntegration }: Props) => {
    const { params: { providerId } }: RouterParams = useRouteMatch();
    const { search } = useLocation();

    useEffect(() => {
        const { state, code, ...anotherParams } = parseQS<QueryParams>(search);
        const provider: OAuthStrategyOptions = OAuthCache.get(providerId);

        const forwardParams = getAdditionalParamsFromQuerystring(
            anotherParams, provider.forwardProps,
        );

        startIntegration({
            providerId: provider.id,
            authorizationServerUrl: provider.authorizeUrl,
            state,
            params: {
                ...forwardParams,
                redirect_uri: getRedirectUri(provider.id),
                code,
            },
        });
    }, [providerId, search, startIntegration]);

    return (
        <Loading />
    );
};

export const OAuthStrategyCallbackComponent = connect(
    null,
    dispatch => bindActionCreators({
        startIntegration: startIntegrationFlow,
    }, dispatch),
)(OAuthStrategyCallbackComponentImpl);
